// removed by extract-text-webpack-plugin
module.exports = {"review":"_1vv0w","photo":"_9sMfR","details":"_24fQt","reviewerName":"ngZ7Y","reviewerTitle":"_3TvFS","reviewText":"_1JzJF","showOnMobile":"_3CPiF","showOnDesktop":"_1tAFZ","ratingBadge":"EiNJK"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordReview/index.sass
// module id = 1481
// module chunks = 1